export const EVENT_URI = 'wm26';
export const COUNTDOWN_EVENT_DATE = '2026-06-29T14:00:00+02:00';

export const GEM_ATTENDEE_TYPES = ['Sapphire', 'Ruby', 'Diamond', 'Emerald'];

export const DEFAULT_OVERALL_PROGRAM_PDF = 'https://cdn.eventtia.com/event_files/236077/original/OVERAL_PROGRAM.pdf?1779478420';

export const GEM_SCHEDULE_PDFS = {
  sapphire: 'https://cdn.eventtia.com/event_files/237845/original/SCHEDULE_SAPPHIRE.pdf?1781885547',
  ruby: 'https://cdn.eventtia.com/event_files/237846/original/SCHEDULE_Ruby.pdf?1781885724',
  emerald: 'https://cdn.eventtia.com/event_files/237847/original/SCHEDULE_Emerald.pdf?1781885732',
  diamond: 'https://cdn.eventtia.com/event_files/237848/original/SCHEDULE_DIAMOND.pdf?1781885743',
};

export const INTERNAL_IDS = {
  topPlainText: '300', // campo de texto plano que debe ir arriba de todos los demás
  terms: '120',
  firstName: '130',
  lastName: '131',
  usedNameIfDifferent: '110',
  company: '133',
  jobTitle: '135',
  category: '14',
  // headline: '13', // not used in wm-2026
  // role: '14', // not used in wm-2026
  linkedInProfile: '161',
  customTelephone: '134',
  email: '132',
  assistantEmail: '106',
  nationality: '18',
  passportNumber: '113',
  birthdate: '136',
  passportExpiryDate: '114',
  downloadInvitationLetter: '193',
  emergencyContactName: '199',
  emergencyContactPhone: '1991',
  photo: '194',
  accompanyingGuest: '1951',
  accGuestFirstName: '195112',
  accGuestLastName: '19111',
  guestJoiningCWICeremony: '1955',
  guestEmailAddress: '19551',
  guestSharingTransfers: '1953',
  guestSameRoom: '1952',
  twinOrDoubleBed: '19521',
  commentAboutProfile: '1954',
  hotelName: '121',
  checkIn: '117',
  checkOut: '118',
  typeOfBedroom: '26',
  typeOfGuests: '119',
  zones: '126',
  zonesDetails: '122',
  communities: '123',
  vip: '124',
  workshopGroup: '125',
  billing: '27',
  transfer: '3',
  arrivalDate: '108',
  needArrivalAirportTransfer: '115',
  arrivalFlightNumber: '100',
  arrivalTime: '101',
  arrivalFrom: '102',
  arrivalTo: '1021',
  arrivalComments: '324',
  departureDate: '107',
  needDepartureAirportTransfer: '116',
  departureFlightNumber: '103',
  departureTime: '104',
  departureFrom: '1051',
  departureTo: '105',
  departureComments: '344',
  departurePickUpTime: '111',
  dietaryRequirements: '112',
  specifyYourSpecialDiet: '42',
  medicalFoodAllergies: '411',
  sundayDinner: '51',
  yourActivityTitle: '7',
  myHeight: '61',
  needHelpPhone: 'needHelpPhone',
  flightTicket: '36',
  hotelReservation: '27',
  expoEntranceMay21: '74',
  expoEntranceMay22: '75',
  ExcoFilter: '50',
};

export const WORKSHOP_CATEGORIES = {
  mandatory: '9833',
  optional: '9834',
  plenieres: '8811',
  workshops: '8812',
  soirees: '8813',
  activites: '9869',
  umbrella: '9868',
  umbrellaMulti: '9890',
  umbrellaChild: '9879',
  Exco: '9906',
  hidden: '',
  noRegister: '9919',
};

export const UMBRELLA_ACTIVITY_ID = '511556'; // TODO: Update to wm-2026 ID
export const VIRTUAL_ATTENDEE_TYPE_ID = '179929'; // TODO: Update to wm-2026 ID
export const ACTIVE_MODULES = ['Workshops', 'Attendees', 'Custom', 'AttendeeProfile', 'Sponsors', 'Surveys', 'Speakers', 'SocialWall', 'AttendeeLeads', 'QASessions', 'Quizzes'];

const INPUT_TYPES = {
  TEXT_FIELD: 1,
  TEXT_AREA: 2,
  CHECKBOX: 3,
  SELECT: 4,
  RADIO: 5,
  IMAGE: 6,
  LABEL: 7,
  CITY: 8,
  FILE: 9,
  DATE_TIME: 10,
  RATING: 11,
  TERMS_CONDITIONS: 20,
  DOWNLOAD_BUTTON: 500,
};

export default INPUT_TYPES;

export const ATTENDANCE_MODE = {
  PHYSICAL: 'offline',
  VIRTUAL: 'online',
  HYBRID: 'mixed',
};

export const STAGE_TAB_NAMES = {
  TIMELINE: 0,
  CHAT: 1,
};

export const MEETING_REQUEST_STATUSES = {
  REQUESTED: 'requested',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};

export const MEETING_REQUEST_TYPES = {
  RECEIVED: 'received',
  SENT: 'sent',
};

// Empty placeholders — cwi2026-specific, not needed for wm-2026
export const ACTVITIES_WITH_REPLAY = {};
export const REPLAYS = {};
